import { PARTICIPACAO_LABEL, PARTICIPACAO_MAX, type PassoParticipacao } from "../types";

/** Leitura compacta da escada de participação: 10 barrinhas que enchem até o passo. */
export function ParticipacaoMini({ passo }: { passo: PassoParticipacao | null }) {
  const v = passo ?? -1;
  const rotulo = passo === null ? "sem momentos ainda" : PARTICIPACAO_LABEL[passo];
  return (
    <div className="escada-mini" role="img" aria-label={`participação: ${rotulo}`}>
      {Array.from({ length: PARTICIPACAO_MAX + 1 }, (_, i) => (
        <i
          key={i}
          className={i <= v ? "on" : ""}
          style={{ height: `${30 + (i / PARTICIPACAO_MAX) * 70}%` }}
        />
      ))}
    </div>
  );
}
